import { cva, type VariantProps } from 'class-variance-authority'

export { default as Icon } from './Icon.vue'

export const iconVariants = cva(
  'inline-flex items-center justify-center shrink-0 transition-colors',
  {
    variants: {
      variant: {
        default: 'text-current',
        muted: 'text-muted-foreground',
        destructive: 'text-destructive',
        success: 'text-green-600',
        warning: 'text-yellow-600',
        info: 'text-blue-600',
        primary: 'text-primary',
        secondary: 'text-secondary-foreground',
      },
      size: {
        default: 'h-4 w-4',
        sm: 'h-3 w-3',
        lg: 'h-5 w-5',
        xl: 'h-6 w-6',
        icon: 'h-4 w-4',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export type IconVariants = VariantProps<typeof iconVariants>
export { type IconName, getAvailableIcons, hasIcon } from './registry'
export { createSvgIconComponent, SvgIcons } from './icon-wrapper'